<template>
  <div class="head-top">
    <m-contact-us />
      <span class="d-flex justify-content-end">
          <span class="head-top-item">
              <b-link href="tel://800-399-8611">
              800-399-8611 </b-link>
          </span>
          <span class="head-top-item">
               <b-link @click="showContactUs"
                  class="contact-us"
                  target="_blank">
                    Contact Us
                    </b-link>
          </span>
          <span class="head-top-item">
             <icon name="twitter" class="twitter-icon"></icon>
             <b-link :href="$store.state.config.link.twitter"
                target="_blank">
               Follow @SL360.com
             </b-link>
          </span>
      </span>
  </div>
</template>
<script>
  import MContactUs from '@/components/landings/MContactUs'

  export default {
    components: {
      MContactUs
    },
    data () {
      return {

      }
    },
    created () {
    },
    methods: {
      showContactUs () {
        this.$root.$emit('bv::show::modal', 'modalContactUs')
      }
    }
  }
</script>

<style scoped lang="scss">
  .head-top{
    background-color: $color-primary-light;
  }
  .head-top-item{
    padding: 12px;
    border-left: 1px solid $color-border;
    color: rgba(0, 0, 0, 0.55);
    font-size: 11px;
    display: flex;
    align-items: center;
  }
  .twitter-icon {
    color: $color-primary;
    cursor: pointer;
    height: 16px;
    margin-right: 8px;
  }
  .contact-us:not([href]):not([tabindex]) {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/MHeaderTop.vue